
  import React, { useState,useCallback } from "react";
  import {Route, Routes,useNavigate} from 'react-router-dom'
  import ProductcronjobsPage from "../generatedTablePage/ProductcronjobsPage";
  import ModalComponent from "../components/Modal";
  import { Outlet } from "react-router-dom";
  import AddProductcronjobs from "../generatedAddEdit/productcronjobs/AddProductcronjobs";
  import EditProductcronjobs from "../generatedAddEdit/productcronjobs/EditProductcronjobs";
  

  
  
  const ProductcronjobsRoutes = () => {


    return (
      <Routes> 
      
    <Route
    path="/"
    element={<ProductcronjobsPage/>}
  />
  <Route
    path="/edit"
    element={
      <EditProductcronjobs/>
    }
  />
  <Route
    path="/add"
    element={
      <AddProductcronjobs/>
    }
  />      
         
      </Routes>
    );
  };
  export default ProductcronjobsRoutes
